import { styled } from "@mui/material/styles";
import { Skeleton, Stack, Typography } from "@mui/material";

import { TableRowItem } from "../../components/table";
import { capitalizeFirstLetter, getDateTime } from "../../utils";
import { TableRowContainer, TableRow } from "../../components/table";

interface WithdrawHistoryItemProps {
	index: number
	data: WithdrawHistoryObject
}

const WithdrawHistoryItem = ({ data, index }: WithdrawHistoryItemProps) => {
	return (
		<TableRowContainer expanded={false} onChange={() => { }}>
			<TableRow>
				<TableRowItem item xs={12} md={6} lg={4} xl={3}>
					<RowItemContainer>
						<Stack width={20}>{index}.</Stack>
						<Typography variant="body2">{data.currency.toUpperCase()}</Typography>
					</RowItemContainer>
				</TableRowItem>

				<TableRowItem item xs={12} md={6} lg={4} xl={3}>
					<Typography variant="body2">${data.amount}</Typography>
				</TableRowItem>

				<TableRowItem item xs={12} md={6} lg={4} xl={3}>
					<Typography variant="body2">{capitalizeFirstLetter(data.status)}</Typography>
				</TableRowItem>

				<TableRowItem item xs={12} md={6} lg={4} xl={3}>
					<Typography variant="body2">
						{getDateTime(data.created)}
					</Typography>
				</TableRowItem>
			</TableRow>
		</TableRowContainer>
	)
}

const WithdrawHistoryItemSkeleton = ({ index }: { index: number }) => {
	return (
		<TableRowContainer>
			<TableRow>
				<TableRowItem item xs={12} md={6} lg={4} xl={3}>
					<Stack flex={1} direction='row' gap={1} alignItems='center'>
						<Stack width={20}>{index}.</Stack>
						<Skeleton variant="text" height={35} width="50%" />
					</Stack>
				</TableRowItem>

				<TableRowItem item xs={12} md={6} lg={4} xl={3}>
					<Skeleton variant="text" height={35} width="50%" />
				</TableRowItem>

				<TableRowItem item xs={12} md={6} lg={4} xl={3}>
					<Skeleton variant="text" height={35} width="50%" />
				</TableRowItem>

				<TableRowItem item xs={12} md={6} lg={4} xl={3}>
					<Skeleton variant="text" height={35} width="50%" />
				</TableRowItem>
			</TableRow>
		</TableRowContainer>
	)
}

const RowItemContainer = styled(Stack)(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	alignItems: "center",
	gap: theme.spacing(1),
	overflow: "hidden",

	p: {
		flex: 1,
		overflow: "hidden",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
	}
}))

export { WithdrawHistoryItem, WithdrawHistoryItemSkeleton }